import {
    Component,
    ChangeDetectionStrategy,
    OnInit,
    ViewChild,
    ChangeDetectorRef,
    OnDestroy
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { SellingTypeEnum } from '@classifieds-sell/datalayer';
import { FormHelperService, ValidatorPipe } from '@classifieds-sell/shared';
import { MotorsDraftFacade } from '@classifieds-sell/state';
import { Subject } from 'rxjs';
import { MotorsSectionBase } from '../motors-section-base';
import { isEditOrRelistPage, isEditPage } from '@classifieds-sell/shared';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'motors-vehicle-details-details-section',
    templateUrl: './motors-vehicle-details-details-section.component.html',
    styleUrls: ['./motors-vehicle-details-details-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MotorsVehicleDetailsDetailsSectionComponent
    extends MotorsSectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();
    inputDisabled: boolean;

    @ViewChild('motorsVehicleDetailsDetailsSectionForm')
    motorsVehicleDetailsDetailsSectionForm: NgForm;

    constructor(
        public draftFacade: MotorsDraftFacade,
        private _changeDetectorRef: ChangeDetectorRef,
        private _formHelperService: FormHelperService,
        private route: ActivatedRoute,
        private _validatorPipe: ValidatorPipe
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.setInputDisable();
            this._changeDetectorRef.markForCheck();
        });
    }

    setInputDisable(){
        this.inputDisabled = isEditPage(this.route)
            && this.draftData.listingDetails.sellingType === SellingTypeEnum.auction
            && this.metadata.bidCount > 0;
    }

    lengthValidation() {
        return this._validatorPipe.transform({
            name: 'Length',
            validations: {
                required: { value: true },
                customValidation: {
                    errorMessage:
                        this.draftData.vehicleDetails.lengthUnit ===
                        'Metres' ? 'Length has to be at greater than 0 and no more than 100 metres'
                        : this.draftData.vehicleDetails.lengthUnit ===
                            'Feet' ? 'Length has to be at greater than 0 and no more than 328 feet'
                        : 'Length is too long', // how did we get here?
                    enable: true,
                    validate: (length: number) => {
                        if (this.draftData.vehicleDetails.lengthUnit === 'Metres' && (length === 0 || length > 100)) {
                            return false;
                        }
                        if (this.draftData.vehicleDetails.lengthUnit === 'Feet' && (length === 0 || length > 328)) {
                            return false;
                        }

                        return true;
                    }
                }
            }
        });
    }

    engineSizeUnitValidation() {
        return this._validatorPipe.transform({
            name: 'Engine size unit',
            validations: {
                required: { value: this.draftData.vehicleDetails.engineSize !== null }
            }
        });
    }

    isValid(): boolean {
        this._formHelperService.validate(
            this.motorsVehicleDetailsDetailsSectionForm
        );
        return this.formValidationWhenDisabled(this.motorsVehicleDetailsDetailsSectionForm);
    }

    protected formValidationWhenDisabled(ngForm: NgForm): boolean {

        // if page is  a edit page when startDate > 7 then all inputs are disabled => form should be valid
        const isFormDisabled = ngForm.form.disabled;

        return (((isEditOrRelistPage(this.route) && isFormDisabled)
            || ngForm.form.valid));
    }

    dirty(): boolean {
        return this.motorsVehicleDetailsDetailsSectionForm.form.dirty;
    }
}
